import { Fragment } from "react/jsx-runtime";
import { useBreadcrumbs } from "./BreadcrumbContext";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

function AppBreadcrumb() {
  const { breadcrumbs } = useBreadcrumbs();

  const getBreadcrumbInner = (crumb: any, index: any) => {
    return (
      <Fragment key={index}>
        <BreadcrumbItem key={`${index}-item`}>
          {index < breadcrumbs.length - 1 && (
            <BreadcrumbLink
              key={`${index}-link`}
              href={crumb.path}
              className={`inline-block ${index == 0 ? "font-bold text-primary" : ""}`}
            >
              {crumb.name}
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>
        <BreadcrumbSeparator key={`${index}-sep`} />
      </Fragment>
    );
  };

  const getBreadcrumbLeaf = (crumb: any, index: any) => {
    return (
      <BreadcrumbItem key={`${index}-item`}>
        <BreadcrumbPage
          className={`max-w-24 inline-block truncate ... sm:max-w-48 ${index == 0 ? "font-bold text-primary" : ""}`}
        >
          {crumb.name}
        </BreadcrumbPage>
      </BreadcrumbItem>
    );
  };

  const getBreadcrumbItem = (crumb: any, index: any) => {
    if (index < breadcrumbs.length - 1) {
      return getBreadcrumbInner(crumb, index);
    }
    return getBreadcrumbLeaf(crumb, index);
  };

  return (
    <Breadcrumb>
      <BreadcrumbList>{breadcrumbs.map((crumb, index) => getBreadcrumbItem(crumb, index))}</BreadcrumbList>
    </Breadcrumb>
  );
}

export default AppBreadcrumb;
